// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
export const escapeRegex = (regex: string) => {
  return regex.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')
}
